import { useNavigate } from 'react-router-dom'
import { Vars } from '@carrent/ui'
import { RUB } from './format'

/**
 * Гаджет: расход топлива.
 *
 * Норматива расхода в системе нет, поэтому «перерасход» не считаем —
 * сравнивать не с чем. Вместо этого показываем разброс по машинам:
 * машина вдвое прожорливее соседней видна и без норматива.
 */
export function FuelUsageWidget({ data }) {
  const navigate = useNavigate()

  if (!data.refuels) {
    return <p className="widget-empty">За период заправок не зафиксировано</p>
  }

  const max = Math.max(...data.cars.map((c) => c.per_100km), 1)

  return (
    <div className="fuel">
      <div className="fuel__head">
        <span className="fuel__value">
          {data.per_100km != null ? `${data.per_100km} л` : '—'}
        </span>
        <span className="fuel__label">на 100 км по парку</span>
      </div>

      <p className="fuel__basis">
        {RUB.format(data.liters)} л на {RUB.format(data.distance)} км ·
        {' '}{data.refuels} заправок за {data.period_days ?? '—'} дн.
      </p>

      {data.cars.length > 0 && (
        <ul className="widget-list">
          {data.cars.map((c) => (
            <li key={c.car_id}>
              <button
                type="button"
                className="fuel__row"
                onClick={() => navigate(`/admin/cars/${c.car_id}`)}
              >
                <span className="fuel__car">
                  {c.car}
                  {c.plate ? <span className="plate">{c.plate}</span> : null}
                </span>
                <span className="fuel__track">
                  <Vars
                    as="span"
                    className="fuel__bar"
                    vars={{ '--bar-w': `${(c.per_100km / max) * 100}%` }}
                  />
                </span>
                <span className="fuel__num">{c.per_100km} л</span>
              </button>
            </li>
          ))}
        </ul>
      )}

      <p className="widget-note">
        Заправка и пробег берутся за один период, поэтому на коротком
        интервале цифра гуляет: залитое в конце периода израсходуется
        уже в следующем.
      </p>
    </div>
  )
}
